export const COMPANY = "ISHAAN WORLDLINK LLP";
export const PHONE_DISPLAY = "+91 98257 23825";
export const PHONE_TEL = "tel:+919825723825";
export const EMAIL = "info.ishaanworldlink@gmail.com";
export const WHATSAPP_URL = `https://wa.me/919825723825?text=${encodeURIComponent(
    "Hello Ishaan Worldlink, I would like to enquire about your timber products."
)}`;

// logo-dark.png = dark artwork, for light/white backgrounds
// logo-light.png = light artwork, for dark/wooden backgrounds
export const LOGO_DARK = "/assets/logo-dark.png";
export const LOGO_LIGHT = "/logo%20light.jpeg";

export const u = (id, w = 1600) =>
    `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

export const IMG = {
    hero: "/teak front.JPG",
    planks: "photo-1634672652995-ee7525bce595",
    journeyLogs: "/journey-logs.jpeg",
    teakLogs: "/teak-logs.jpg",
    mill: "photo-1473023914974-0d98f0798b51",
    precision: "photo-1590635022668-81cc8696a19d",
    pine:  "/pine%20jpg.jpeg",
    spruce: "photo-1564512533667-015a90133f04",
    grainDark: "photo-1736506159893-22cca29b8018",
    grainDark2: "photo-1736506159776-22ca388780fa",
    grainOak: "photo-1546484396-fb3fc6f95f98",
};

export const NAV_LINKS = [
    { to: "/", label: "Home" },
    { to: "/products", label: "Products" },
    { to: "/gallery", label: "Gallery" },
    { to: "/about", label: "About Us" },
    { to: "/contact", label: "Contact Us" },
];
